module.exports = __webpack_public_path__ + "img/landing-page-login.a8abb5eb.svg";